import React, {useContext} from 'react';
import home_light from '../assets/images/home_light.svg';
import { AppContext } from '../components/AppContext';

const NavBar = () => {

  const { config } = useContext(AppContext)
  if(config){
    return (
      <>
      <div className="home-button">
        <a href={config.navbar.url}>
          <img 
            alt="Home Icon" 
            src={home_light} 
            width="30" 
            height="30" 
            className="d-inline-block align-top"
          />
        </a>
      </div>    
        <div className="separator"></div>
        <div className="label">
          {config.navbar.label}
        </div>
      </>
    );
  }  
};

export default NavBar;
